var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1699 17.2566L20.9813 21.068M19.8812 10.6497C19.8812 15.831 15.6948 20.031 10.532 20.031C5.36803 20.031 1.18164 15.831 1.18164 10.6509C1.18164 5.46713 5.36803 1.26837 10.5308 1.26837C15.6948 1.26837 19.8812 5.46837 19.8812 10.6497Z",
    stroke: "white",
    strokeWidth: 1.85622,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.59e48dc2b6effda7a5b464fbd68856a8.svg";
export { ForwardRef as ReactComponent };